<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              defaultMdOption="all"
              defaultSmdOption="all"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MASS_EXTC_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="comboUseYn"
              :selected="frame0.selectData.COD_BIG_QUANTITY_YN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_EXTC_TYPE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.selectData.typeNameSearchText"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_REQ_DATE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              ref="dp"
              v-model="frame0.selectData.dataExtractionRequestRangeDT"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="comboRequestStatus"
              :selected="frame0.selectData.COD_DATA_EXTC_RQS_STT"
              codeId="COD_DATA_EXTC_RQS_STT"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USR_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.selectData.firstRegistrationUserName"
              :disabled="userNameDisabled"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="listGrid"
        :columns="gridColumns"
        :dataset="'dataset0'"
        :initial-pagesize="10"
        :showDisplayCountControl="false"
        :enabletooltips="true"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:create="'PGE_CMS_00012'"
          type="button"
          class="comm_btn_solid"
          @click="onNewClick"
        >
          {{ $t('MSG_BTN_RGST') }}
        </sui-button>
      </div>
      <sui-popup
        v-model="isShownPopupNew"
        :title="$t('MSG_TIT_DATA_EXTC_RQS')"
      >
        <p01
          :pageId="this.$options.name"
          @close="popNewClose()"
        />
      </sui-popup>
      <sui-popup
        v-model="isShownPopupDetail"
        :title="$t('MSG_TIT_DATA_EXTC_RQS_DTL')"
      >
        <p02
          :pageId="this.$options.name"
          :selectedGridRowData="selectedGridRowData"
          @close="popDetailClose()"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';
import p01 from './components/PGE_CMS_00012_P01';
import p02 from './components/PGE_CMS_00012_P02';

export default {
  name: 'PGE_CMS_00012', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
    p02,
  },
  extends: BasePage,
  data() {
    return {
      userNameDisabled: false,
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_BIG_QUANTITY_YN: {
            label: '',
            key: '',
          },
          COD_DATA_EXTC_RQS_STT: {
            label: '',
            key: '',
          },
          typeNameSearchText: '',
          dataExtractionRequestRangeDT: { from: '', to: '' },
          firstRegistrationUserName: '',
        },
      },
      localdata0: [
      ],
      gridColumns: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_DATA_EXTC_TYPE_NM'),
        datafield: 'dataExtractionTypeName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
            type: 'link',
          }, this.dataset0, this.$refs.listGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MASS_EXTC'),
        datafield: 'dataExtractionBigQuantityYn',
        width: 80,
      }, {
        text: this.$t('MSG_TXT_RQS_USR'),
        datafield: 'firstRegistrationUserId',
        width: 200,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            type: 'link',
          }, this.dataset0, this.$refs.listGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_REQ_DATE'),
        datafield: 'dataExtractionRequestStartDT',
        width: 90,
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dataset0, this.$refs.listGrid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      }, {
        text: this.$t('MSG_TXT_RGST_DTM'),
        datafield: 'firstRegistrationDTM',
        width: 150,
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dataset0, this.$refs.listGrid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      }, {
        text: this.$t('MSG_TXT_STT'),
        datafield: 'dataExtractionRequestStateName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_RSULT'),
        datafield: 'dataExtractionResultFilePath',
        width: 150,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onDownloadButtonClicked,
          }, this.dataset0, this.$refs.listGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
      isShownPopupNew: false,
      isShownPopupDetail: false,
      selectedGridRowData: {},
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      {
        name: 'dataExtractionTypeUid',
        type: 'string',
        map: 'dataExtractionTypeUid',
      },
      {
        name: 'moduleName',
        type: 'string',
        map: 'moduleName',
      }, {
        name: 'subModuleName',
        type: 'string',
        map: 'subModuleName',
      }, {
        name: 'dataExtractionTypeName',
        type: 'string',
        map: 'dataExtractionTypeName',
      }, {
        name: 'dataExtractionBigQuantityYn',
        type: 'string',
        map: 'dataExtractionBigQuantityYn',
      }, {
        name: 'firstRegistrationUserId',
        type: 'string',
        map: 'firstRegistrationUserId',
      }, {
        name: 'dataExtractionRequestStartDT',
        type: 'string',
        map: 'dataExtractionRequestStartDT',
      }, {
        name: 'firstRegistrationDTM',
        type: 'string',
        map: 'firstRegistrationDTM',
      }, {
        name: 'dataExtractionRequestStateName',
        type: 'string',
        map: 'dataExtractionRequestStateName',
      }, {
        name: 'dataExtractionResultFilePath',
        type: 'string',
        map: 'dataExtractionResultFilePath',
      }, {
        name: 'displayLanguageId',
        type: 'string',
        map: 'displayLanguageId',
      }, {
        name: 'knoxId',
        type: 'string',
        map: 'knoxId',
      }, {
        name: 'userName',
        type: 'string',
        map: 'userName',
      }, {
        name: 'userGlobalName',
        type: 'string',
        map: 'userGlobalName',
      },
    ],
  }],
  mounted() {
    this.setSessionUserName();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    setSessionUserName() {
      this.frame0.selectData.firstRegistrationUserName = this.$store.getters.userInfo.userName;
      this.userNameDisabled = true;
    },
    onResetClick() {
      // this.$refs.smComboFrame0.reset();
      this.$refs.smComboFrame0.selectMd('ALL');
      this.$refs.comboUseYn.reset();
      this.frame0.selectData.typeNameSearchText = '';
      this.frame0.selectData.dataExtractionRequestRangeDT = { from: '', to: '' };
      this.$refs.comboRequestStatus.reset();
      // this.frame0.selectData.firstRegistrationUserName = '';
    },
    onSearchClick() {
      if (this.onClickValidate()) return false;

      const codeValue = this.frame0.selectData;
      const queryParams = {
        moduleCode: utils.trim(codeValue.COD_MDLE.key),
        subModuleCode: utils.trim(codeValue.COD_SMDLE.key),
        dataExtractionBigQuantityYn: utils.trim(codeValue.COD_BIG_QUANTITY_YN.key),
        dataExtractionTypeName: utils.trim(this.frame0.selectData.typeNameSearchText),
        dataExtractionRequestFromDT: utils.dateformatToServer(this.frame0.selectData.dataExtractionRequestRangeDT.from, 'S'),
        dataExtractionRequestToDT: utils.dateformatToServer(this.frame0.selectData.dataExtractionRequestRangeDT.to, 'S'),
        dataExtractionRequestStateCode: utils.trim(codeValue.COD_DATA_EXTC_RQS_STT.key),
        firstRegistrationUserName: utils.trim(this.frame0.selectData.firstRegistrationUserName),
        firstRegistrationUserId: utils.trim(this.$store.getters.userInfo.userId),
      };

      http.request(this.$options.name, 'DTS_CMS_00041', {
        query: queryParams,
      }).then(res => {
        this.localdata0 = res.data;
        utils.forEach(res.data, item => {
          utils.forEach(item, (values, key) => {
            if (key === 'dataExtractionResultFilePath') {
              // eslint-disable-next-line no-param-reassign
              if (values) { item[key] = [{ key: values, label: 'Download', type: 'positive' }]; }
            }
          });
        });
        this.dataset0.setRawData(this.localdata0);
      });

      return null;
    },
    onNewClick() {
      this.selectedGridRowData = {};
      this.isShownPopupNew = true;//! this.isShownPopupNew;
    },
    onGridButtonClicked(btn, dataRow) {
      this.selectedGridRowData = dataRow;
      this.isShownPopupDetail = true;
    },
    popNewClose() {
      this.isShownPopupNew = false;
      this.onSearchClick();
    },
    popDetailClose() {
      this.isShownPopupDetail = false;
    },
    onDownloadButtonClicked(btn, dataRow) {
      const fileName = dataRow.dataExtractionResultFilePath[0].key;
      const queryParams = {
        originalFileName: fileName,
        serverFileName: fileName,
      };
      http.request(this.$options.name, 'DTS_CMZ_00068', {
        path: { 'target-path': 'export' },
        query: queryParams,
        responseType: 'arraybuffer',
      }).then(res => {
        utils.downloadBlob(res, fileName);
      });
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
